import React, { useCallback } from 'react';
import { View } from 'react-native';
import { Text, TextInput } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { UserSelector } from '../../components/selector';
import { MANUAL_RESTOCK_WARNING } from '../../../common/utils/vending-settings';
import { PREDEFINED_USER_ROLES } from '../../../common/constants';

const ManualRestockDetails = ({
	changeFormValue,
	values,
}) => {
	const styles = useThemedStyles(createStyles);

	const handleOnChange = useCallback(field => value => {
		changeFormValue({ [field]: value });
	}, [changeFormValue]);

	return (
		<View style={styles.container}>
			<Text style={styles.warning}>{MANUAL_RESTOCK_WARNING}</Text>
			<View style={styles.field}>
				<Text style={styles.label}>
					Describe the reason why you want to use the manual restock option.
				</Text>
				<TextInput
					multiline={true}
					numberOfLines={3}
					style={styles.comment}
					value={values.manualRestockComment}
					onChange={handleOnChange('manualRestockComment')}
				/>
			</View>
			<View style={styles.field}>
				<Text style={styles.label}>
					Approved by (<Text style={styles.labelStrong}>call</Text> selected person for permission first):
				</Text>
				<UserSelector
					initialValue={values.manualRestockApprovedBy}
					onChange={newUser => changeFormValue({ manualRestockApprovedBy: newUser })}
					placeholder="Select manager"
					initialFilter={{
						predefinedRoleName: PREDEFINED_USER_ROLES.ADMIN,
					}}
				/>
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		gap: space.md,
		paddingVertical: space.sm,
	},
	warning: {
		...type.bodySmall,
		color: colors.text,
	},
	field: {
		gap: space.xs,
	},
	label: {
		...type.secondary,
		color: colors.textSecondary,
	},
	labelStrong: {
		...type.secondarySemibold,
		color: colors.text,
	},
	comment: {
		height: 100,
	},
});

export default ManualRestockDetails;
